import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const HomePage = () => {
  const services = [
    {
      icon: 'ri-car-line',
      title: 'Maintenance',
      description: 'Oil Changes, Tune-Ups, Factory Recommended Maintenance, Timing Belt Replacement, Transmissions'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Engine',
      description: 'Engine Repair & Replacement'
    },
    {
      icon: 'ri-tools-line',
      title: 'Inspections',
      description: 'Pre-Purchase Inspections, Maintenance Inspection'
    },
    {
      icon: 'ri-wheel-line',
      title: 'Wheels & Tires',
      description: 'Tire Mounting & Balancing, Flat Repair, Rotation, Alignments'
    },
    {
      icon: 'ri-car-washing-line',
      title: 'Suspension',
      description: 'Suspension & Steering Repair, Shocks and Struts'
    },
    {
      icon: 'ri-brake-line',
      title: 'Brakes',
      description: 'Brake and ABS Repair'
    },
    {
      icon: 'ri-computer-line',
      title: 'Systems',
      description: 'Electrical System Diagnosis & Repair, Air Conditioning Service & Repair, Cooling System Service & Repair'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'State Inspection',
      description: 'Emission Check'
    },
    {
      icon: 'ri-snowflake-line',
      title: 'A/C Service',
      description: 'Cooling System Service, Repair Air Filter'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-cover bg-center bg-no-repeat min-h-screen flex items-center" 
               style={{backgroundImage: `url('https://public.readdy.ai/ai/img_res/648fc77cf6fac81ac900f689f6691f5a.jpg')`}}>
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-2xl">
            {/* Logo */}
            <div className="flex justify-center lg:justify-start mb-8">
              <div className="bg-red-700 text-white px-6 py-3 rounded-lg shadow-2xl">
                <div className="flex items-center space-x-3">
                  <i className="ri-tools-fill text-4xl"></i>
                  <div className="text-left">
                    <div className="text-3xl font-bold leading-tight">SAGIL</div>
                    <div className="text-lg font-medium leading-tight">SERVICE</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">
                SAGIL AUTO SERVICE
              </h1>
              <p className="text-xl text-gray-200">Quality Auto Repairs Since 1987</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Quality Auto Repairs with Excellence
              </h2>
              <p className="text-lg text-gray-700 mb-6">
                Sagil Service has been providing the community and surrounding areas with only the highest quality of automotive service available. Our number one priority is to make our customers feel confident that not only was their car maintained and repaired by only the best technicians with many years of combined experience and with the utmost respect for your vehicle, but that YOU, the customer were treated with respect.
              </p>
              <p className="text-lg text-gray-700 mb-8">
                We are a full-service maintenance and repair facility that is capable of working on all makes and models, foreign and domestic. We deliver quality auto repairs that you can trust!
              </p>
              <Link 
                to="/about" 
                className="inline-flex items-center px-6 py-3 bg-red-700 hover:bg-red-600 text-white font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Learn More About Us
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20automotive%20technician%20working%20on%20car%20engine%20in%20clean%20modern%20garage%2C%20wearing%20uniform%2C%20using%20diagnostic%20tools%2C%20focused%20on%20quality%20repair%20work%2C%20well-lit%20workspace%20with%20organized%20tools%20and%20equipment&width=600&height=400&seq=technician-work&orientation=landscape"
                alt="Professional automotive technician at work"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
              <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-lg shadow-lg">
                <div className="text-center">
                  <div className="text-2xl font-bold text-red-700">Quality</div>
                  <div className="text-sm text-gray-600">Guaranteed</div>
                  <div className="text-sm font-semibold text-gray-900">Right First Time</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Warranty Section */}
      <section className="py-12 bg-red-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="flex items-center justify-center mb-4">
            <i className="ri-shield-check-fill text-6xl text-yellow-400 mr-4"></i>
            <div>
              <h3 className="text-3xl font-bold">Quality Auto Repairs Guaranteed</h3>
              <p className="text-2xl">Repairs done right the first time, every time!</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Quality Auto Repair Services</h2>
            <p className="text-xl text-gray-600">Complete automotive care for all makes and models</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="text-center p-6 bg-gray-50 rounded-lg hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 mx-auto mb-4 bg-red-700 rounded-full flex items-center justify-center">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <Link 
              to="/services" 
              className="inline-flex items-center px-8 py-4 bg-red-700 hover:bg-red-600 text-white text-lg font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              View All Quality Services
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready for Quality Auto Repairs?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Contact us today to schedule your service appointment or get a quote for your quality automotive repair needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/contact" 
              className="inline-flex items-center px-8 py-4 bg-red-700 hover:bg-red-600 text-white text-lg font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-line mr-2"></i>
              Schedule Service
            </Link>
            <a 
              href="tel:(973) 472-0890" 
              className="inline-flex items-center px-8 py-4 bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white text-lg font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              (973) 472-0890
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
